import { render, staticRenderFns } from "./ProfileFriend.vue?vue&type=template&id=e4c347ac&scoped=true&lang=html&"
import script from "./ProfileFriend.vue?vue&type=script&lang=js&"
export * from "./ProfileFriend.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFriend.vue?vue&type=style&index=0&id=e4c347ac&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c347ac",
  null
  
)

export default component.exports